import React from "react";
import { CameraIcon } from "lucide-react";
import type { Student } from "../../types/hackathon";
import type { TeamPhoto as TeamPhotoData } from "../../data/teamPhotos";
import { initials } from "../../utils/progress";
interface TeamPhotoProps {
  teamId: number;
  members: Student[];
  photo?: TeamPhotoData;
}
export function TeamPhoto({
  teamId,
  members,
  photo
}: TeamPhotoProps) {
  const ordered = photo?.order ? [...members].sort((a, b) => indexOr(photo.order!, a.name) - indexOr(photo.order!, b.name)) : members;
  return <figure data-id="element-668" data-mp="1zagxarrsiydz">
      <div className="relative aspect-[4/3] overflow-hidden rounded-[28px] bg-ink" data-id="element-669" data-mp="1z95r6lavhejp">
        {photo ? <img src={photo.src} alt={`Team ${teamId}: ${ordered.map(m => m.name).join(" and ")}`} style={{
        objectPosition: photo.position ?? "50% 40%"
      }} className="h-full w-full object-cover" data-id="element-670" data-mp="1ldv07izr1dkm" /> : <div className="flex h-full" aria-hidden="true" data-id="element-671" data-mp="ewzsaohfkdm3">
            {ordered.map(m => <span key={m.id} className={`flex flex-1 items-center justify-center font-display text-[clamp(3.5rem,8vw,7rem)] leading-none ${m.school === "link" ? "bg-brgreen text-sun" : "bg-saffron text-ink"}`} data-id="element-672" data-mp="3f48k31kcqt8q">
                {initials(m.name)}
              </span>)}
          </div>}
        {!photo && <span className="absolute bottom-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-cream px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-ink" data-id="element-673" data-mp="1vdn4aa61a5z">
            <CameraIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-674" data-mp="blophse7bbar" />
            Team photo coming soon
          </span>}
      </div>

      <figcaption className="mt-5 flex flex-wrap gap-x-10 gap-y-4" data-id="element-675" data-mp="6q9dz73o1rhi">
        {ordered.map(m => {
        const isLink = m.school === "link";
        return <div key={m.id} data-id="element-676" data-mp="gnnt93dusa88">
              <p className="font-display text-2xl uppercase leading-tight md:text-3xl" data-id="element-677" data-mp="gk9pbqpjjsyo">{m.name}</p>
              <p className="mt-0.5 flex items-center gap-2 text-[12px] font-semibold uppercase tracking-wide text-ink/60" data-id="element-678" data-mp="nng84gkm4b7k">
                <span className={`h-2 w-2 rounded-full ${isLink ? "bg-brgreen" : "bg-saffron"}`} aria-hidden="true" data-id="element-679" data-mp="xnqky02qjgm7" />
                {isLink ? "Link School of Business · Brazil" : "Mahindra University · India"}
              </p>
            </div>;
      })}
      </figcaption>
    </figure>;
}
function indexOr(list: string[], name: string) {
  const i = list.indexOf(name);
  return i === -1 ? list.length : i;
}